export default "__VITE_ASSET__DVYf6S2u__"